import type { LocationModel } from '@/entities/location';

import { COUNTED_LOCATION_TYPES, type CountedLocation, type FilteredLocationCounts } from './types';

/**
 * How many locations of each type the map has, counted over every location the backend
 * returned rather than the ones a layer currently draws — a standing total that should not
 * jump around as layers are switched on and off.
 *
 * Deleted and inactive locations are left out: the endpoint still returns them, because the map
 * draws them exactly as legacy does, but counting them put the figures two above the
 * `projectLocations` report. Locked ones stay — a lock is a stock count in progress, not a
 * retired location, and stock sits at them.
 *
 * Two things it is therefore not: `/locations` covers every site of the project, not the
 * selected location group, and it omits locations without coordinates, so these figures stay
 * below the report by exactly those (360450).
 */
export function countLocationsByType(locations: LocationModel[]): FilteredLocationCounts {
  const counts = Object.fromEntries(COUNTED_LOCATION_TYPES.map((type) => [type, 0])) as FilteredLocationCounts;

  for (const location of locations) {
    if (location.isDeleted || !location.isActive) continue;
    if (location.type in counts) counts[location.type as CountedLocation] += 1;
  }

  return counts;
}
